export default __webpack_public_path__ + "static/media/git.1b6c0741.svg";